import { lazy } from "react";
import { Outlet } from "react-router";
import { routes } from "./index";
import Loadable from "../common/components/loadable";
import ProvidersWrapper from "../context/app-provider";


import ProtectedRoute from "./protect-route";


const AuthLogin = Loadable(lazy(() => import("../pages/auth/login")));


// AUTH ROUTING
const loginRoutes = {
  element: (
    <ProvidersWrapper>
      <Outlet />
    </ProvidersWrapper>
  ),
  children: [
    {
      path: routes.LOGIN,
      element: <ProtectedRoute guestOnly={true}><AuthLogin /></ProtectedRoute>
    },
    // {
    //   path: routes.REGISTER,
    //   element: <ProtectedRoute guestOnly={true}><AuthRegister /></ProtectedRoute>,
    // },
    // {
    //   path: routes.FORGOT_PASSWORD,
    //   element: <ProtectedRoute guestOnly={true}><AuthForgotPassword /></ProtectedRoute>,
    // },
    // {
    //   path: routes.RESET_PASSWORD,
    //   element: <ProtectedRoute guestOnly={true}><AuthResetPassword /></ProtectedRoute>,
    // },
  ],
};

export default loginRoutes;
